import { Verdict } from '@exam-center/graphql';
import { Flex, FormRadioSelection, FormTextField } from '@shared/components';

export default function ExamCenterProctorRequestVerdictFormField() {
  const verdictOptions = [
    { label: 'อนุมัติคำขอ', value: Verdict.Approved },
    { label: 'ไม่อนุมัติคำขอ', value: Verdict.Rejected },
  ];
  return (
    <Flex sx={{ flexDirection: 'column', gap: (theme) => theme.spacing(6) }}>
      <FormRadioSelection
        name='verdict'
        label='ผลการอนุมัติคำขอ'
        options={verdictOptions}
        row
        required
      />
      <FormTextField
        name='comment'
        label='ความคิดเห็นเพิ่มเติม'
        placeholder='ระบุความคิดเห็นเพิ่มเติม'
        multiline
      />
    </Flex>
  );
}
